export const panelStates = {
  // the boolean values represent whether
  // the panel is expanded (true) or collapsed (false)
  panels: {
    sankalpa: false,
    panchangam: true,
    samvatsaradi: false,
    parvaVishesha: false,
    tithiVishesha: false,
    extendedTithiInformation: false,
    extendedNakshatraInformation: false,
  },

  _key: "sringeriPanchangam_panelStates",

  _active: false,

  init() {
    this._loadState();
    Alpine.effect(() => {
      this._saveState();
    });
  },

  _saveState() {
    if (this._active === false) {
      this._active = true;
      localStorage.setItem(this._key, JSON.stringify(this.panels));
      this._active = false;
    } else {
      // Prevent recursive calls
      return;
    }
  },

  _loadState() {
    const savedStates = localStorage.getItem(this._key);
    if (!savedStates) {
      this._saveState();
      return;
    }

    const parsed = JSON.parse(savedStates);

    this.panels = { ...this.panels, ...parsed };

    // Ensure no invalid keys are kept
    this.panels = Object.keys(this.panels).reduce((acc, key) => {
      acc[key] = parsed[key] ?? this.panels[key];
      return acc;
    }, {});

    // Save merged result back
    this._saveState();
  },
};
